import { fireTrack } from "@swa-ui/analytics";

export const fireViewFlightStatusAnalytics = () => {
  fireTrack("squid", { page_description: "accordion: view flight status" });
};

export const fireClearRecentSearchesAnalytics = () => {
  fireTrack("squid", { page_description: "button:flight status clear searches" });
};

export const fireSelectRecentSearchFlightAnalytics = () => {
  fireTrack("squid", { page_description: "button: flight status search selected" });
};

export const fireRecentSearchAnalytics = () => {
  fireTrack("squid", { page_description: "drop down:flight status recent search" });
};
